/**
 * Les NC rattachées à un équipement — module PUR.
 *
 * Retour du 03/10/2026 : « j'ai une NC reliée à l'Indiko 1 mais je ne la vois
 * pas dans les liens et NC de l'équipement ». Une NC désigne un appareil de
 * DEUX façons, écrites par des chemins différents :
 *  - le champ `equipementCode` de la NC (métrologie, calibration, saisie du
 *    champ « Équipement » sur la NC) — aucun lien n'est créé ;
 *  - une ligne du registre des liens (bouton « Lier… », panne déclarée depuis
 *    l'équipement, relevé de température) — le champ reste vide.
 * L'onglet « Liens & NC » ne lisait que la seconde, la fiche de vie que la
 * première : chacune manquait ce que l'autre voyait. Une seule règle, lue aux
 * deux endroits : l'une OU l'autre suffit.
 */
type LienMin = { sourceType: string; sourceRef: string; cibleType: string; cibleRef: string };
type NcMin = { ref: string; equipementCode?: string | null };

/** Références des NC liées à l'équipement par le registre, dans les deux sens. */
export function refsNcLiees(liens: LienMin[], code: string): Set<string> {
  const s = new Set<string>();
  if (!code) return s;
  for (const l of liens) {
    if (l.sourceType === 'equipement' && l.sourceRef === code && l.cibleType === 'nc') s.add(l.cibleRef);
    if (l.cibleType === 'equipement' && l.cibleRef === code && l.sourceType === 'nc') s.add(l.sourceRef);
  }
  return s;
}

/** Les NC rattachées à l'équipement, par le registre des liens OU par leur
 *  champ `equipementCode` (comparaison exacte : c'est le code d'inventaire). */
export function ncsDeLEquipement<N extends NcMin>(ncs: N[], liens: LienMin[], code: string): N[] {
  if (!code) return [];
  const refs = refsNcLiees(liens, code);
  return ncs.filter((n) => refs.has(n.ref) || (n.equipementCode || '') === code);
}
